import { SafetyWarrantySection } from "@/components/support/downloads/ManualSection";
import { useTrans } from "@/utils/useTrans";

const SafetyAndWarranty = () => {
  const { t } = useTrans(["gnb"]);

  return (
    <div>
      <div className={"pt-8 text-2xl font-700 text-coolgray-90 laptop:px-4"}>
        {t("Health and Safety Warnings")}
      </div>
      <div className={"pt-4 laptop:px-4"}>
        {t(
          "Download the health and safety warnings and legal compliance information.",
        )}
      </div>
      <SafetyWarrantySection />
    </div>
  );
};

export default SafetyAndWarranty;
